// @ts-nocheck
import { useState, useEffect, useRef, useReducer } from 'react';
import { Dialog } from "primereact/dialog";
import { ListBox } from 'primereact/listbox';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Slider } from 'primereact/slider';
import { TerrainSiderComponents } from './TerrainSiderComponents';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"


const Layer2DOption = (props) => {
    const [layerList, setLayerList] = useState([]);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    useEffect(() => {
        setLayerList(props.selectedlayer);
    }, [props])

    const layerListShit = (index, nextIndex) => {
        if (nextIndex < 0 || nextIndex >= layerList.length)
            return;
        let layers = layerList;
        let layer = layerList[index];
        layers.splice(index, 1);
        layers.splice(nextIndex, 0, layer);
        setLayerList(layers);
        props.LayerOptionChange(layers);
        forceUpdate();
    }

    const layerListRemove = (index) => {
        let layers = layerList;
        let layer = layerList[index];
        window.main.OView.removeTerrainOverlay(layer.TITLE);
        props.toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉圖層：' + layer.TITLE });
        layers.splice(index, 1);
        setLayerList(layers);
        props.LayerOptionRemove(layers);
        forceUpdate();
    }

    const LayerSlider = (props) => {
        const [value, setValue] = useState(0);

        useEffect(() => {
            setValue(100 - window.main.OView.getTerrainOverlay(props.item.TITLE).opacity * 100)
        }, [props])

        useEffect(() => {
            window.main.OView.getTerrainOverlay(props.item.TITLE).opacity = (100 - value) / 100
        }, [props, value])

        return (
            <div>
                <div className='slider-description'>透明度: {value} %</div>
                <Slider id={props.item.TITLE} value={value} onChange={(e) => setValue(e.value)} />
            </div>
        )
    }
    return (
        <div className="card">
            {
                layerList.map((item, index) =>
                    <div>
                        <div className="layer-item">
                            <div className="layer-detail">
                                <div className="layer-name">{item.TITLE}</div>
                            </div>
                            <div className="layer-action">
                                <Button icon="pi pi-arrow-up" className="p-button-rounded" onClick={() => { layerListShit(index, index - 1) }} />
                                <Button icon="pi pi-arrow-down" className="p-button-rounded" onClick={() => { layerListShit(index, index + 1) }} />
                                <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { layerListRemove(index) }} />
                            </div>
                        </div>
                        <LayerSlider item={item} />
                        <Divider />
                    </div>
                )
            }
        </div>
    )
}

export const Layer2DList = (props: { BaseLayer: any; onHide: (arg0: string) => any; }) => {
    const [selectedlayer, setSelectedlayer] = useState([]);
    const [layerList, setLayerList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);

    useEffect(() => {
        const WMTSLayerList = window.LAYER_GROUP_2DWMTS.WMTS_LAYERS;
        window.LAYER_GROUP_2DWMTS.WMTS_GROUP.map(
            (layers) =>
                window.ov.getWMTSLayerInfo(layers.URL, function (e) {
                    if (e.url && e.identifier) {
                        WMTSLayerList.push({
                            TITLE: e.title || e.identifier,
                            TYPE: "Overlay",
                            ID: e.identifier,
                            URL: e.url
                        });
                    }
                })
        )
        setLayerList(WMTSLayerList);
    }, [])

    useEffect(() => {
        props.setSelected2Dlayer(selectedlayer)
    }, [props, selectedlayer])

    const LayerOptionRemove = (layers) => {
        setSelectedlayer(layers);
        forceUpdate();
    }

    const LayerOptionChange = (layers) => {
        layers.forEach((layer, index) => {
            window.main.OView.moveTerrainOverlay(layer.TITLE, index + 1);
            return;
        })
        setSelectedlayer(layers)
    }

    const LayerOnChange = (layers) => {
        let layer = null;
        if (selectedlayer.length > layers.length) {
            for (let i = 0; i < selectedlayer.length; i++) {
                if (selectedlayer[i] !== layers[i]) {
                    layer = selectedlayer[i];
                    break;
                }
            }
            window.main.OView.removeTerrainOverlay(layer.TITLE);
            toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉圖層：' + layer.TITLE });
            setSelectedlayer(layers);
            return null;
        }
        layer = layers[layers.length - 1];
        if (layers.length <= 15) {
            if (layer.CLASS !== "SingleTile") {
                window.main.OView.addTerrainWMTSOverlay({
                    url: layer.URL,
                    identifier: layer.ID,
                    layername: layer.TITLE,
                    pgmapserver: false,
                    epsg: layer.EPSG || 3857,
                    urlTemplate: "{URL}",
                    token: window.TERRAIN_SERVER.TOKEN
                }, function (e) {
                    if (e.success) {
                        toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    }
                });
            }
            else {
                let param = {};
                param.url = layer.URL;
                param.layername = layer.TITLE;
                param.boundary = new window.GeoBoundary(
                    layer.Boundary.West,
                    layer.Boundary.South,
                    layer.Boundary.East,
                    layer.Boundary.North
                );
                window.main.OView.addTerrainSingleTileOverlay(param);
                toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
            }
            setSelectedlayer(layers);
        }
        else {
            toast.current.show({ severity: 'error', summary: '系統資訊', detail: '為維持較好的使用效能，已達WMTS圖層開啟上限15張' });
        }
    }

    const layerListHeaderTemplate = (options) => {
        return (
            <Button onClick={options.onClick} className={options.className} badge={(layerList.length).toString()}>
                {options.titleElement}
            </Button>
        );
    };

    const selectedLayerHeaderTemplate = (options) => {
        return (
            <Button onClick={options.onClick} className={options.className} badge={(selectedlayer.length).toString()}>
                {options.titleElement}
            </Button>
        );
    };

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="2D圖層列表" visible={props.Layer2D} modal={false} keepInViewport={false} onHide={() => props.onHide('Layer2D')} className="layerList-Dialog">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="圖層列表" headerTemplate={layerListHeaderTemplate}>
                        <TerrainSiderComponents />
                        <ListBox value={selectedlayer} options={layerList} optionLabel="TITLE" multiple filter onChange={(e) => LayerOnChange(e.value)} />
                    </TabPanel>
                    <TabPanel header="已開啟圖層" headerTemplate={selectedLayerHeaderTemplate}>
                        <TerrainSiderComponents />
                        <Layer2DOption selectedlayer={selectedlayer} LayerOptionChange={LayerOptionChange} LayerOptionRemove={LayerOptionRemove} toast={toast} />
                    </TabPanel>
                </TabView>
            </Dialog>
        </div>
    );
}